import React from 'react';
import IconFromImage from '../IconFromImage/IconFromImage';
import listSrc from './assets/list.svg';

const ListIcon = () => (
    <IconFromImage type="funnel" src={listSrc} />
);

export default ListIcon;
